import apiClient from '../apiClient';
import { PUT_USER_PROFILE_URL } from '../apiUrl';

const putUserProfileApi = (id, data) => {
  return apiClient.put(PUT_USER_PROFILE_URL(id), data);
};

export default putUserProfileApi;
